import React, { useEffect, useState } from "react";
import { getFile } from "../../services/FileManager";
import {
  ButtonSpeaker,
  CardSpeaker,
  JobPositionSpeaker,
  SpeakerName,
  useStyles,
} from "./ListOfSpeakers.styled";
import imgSpeaker from "../../assets/img-speaker.png";
import { NotificationManager } from "react-notifications";

const ListOfSpeakers = ({
  nameSpeaker,
  jobPositionSpeaker,
  websiteSpeaker,
  photo,
  emailSpeaker,
  buttonSpeaker,
  descriptionSpeaker,
  setOpenReadMoreModal,
}) => {
  const classes = useStyles();
  const [speakerImage, setSpeakerImage] = useState(imgSpeaker);
  useEffect(() => {
    if (photo) {
      getFile(photo)
        .then((response) => {
          if (response && response.type !== "archivo-noexistente/json") {
            setSpeakerImage(URL.createObjectURL(response));
          } else {
            setSpeakerImage(imgSpeaker);
          }
        })
        .catch((error) => {
          setSpeakerImage(imgSpeaker);
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, []);

  return (
    <CardSpeaker>
      <img src={speakerImage} className={classes.imgSpeaker} alt="" />
      <div style={{ paddingLeft: "10px", width: "70%" }}>
        <SpeakerName>{nameSpeaker}</SpeakerName>
        <JobPositionSpeaker style={{ marginTop: "2rem" }}>
          {jobPositionSpeaker}
        </JobPositionSpeaker>
        <JobPositionSpeaker>{emailSpeaker}</JobPositionSpeaker>
        <ButtonSpeaker
          onClick={() =>
            setOpenReadMoreModal({
              nameSpeaker: nameSpeaker,
              descriptionSpeaker: descriptionSpeaker,
              emailSpeaker: emailSpeaker,
            })
          }
        >
          {buttonSpeaker}
        </ButtonSpeaker>
      </div>
    </CardSpeaker>
  );
};

export default ListOfSpeakers;
